<script setup>
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  headerTitle: {
    type: String,
    default: '',
  },
  headerSubtitle: {
    type: String,
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['click']);

const handleButtonClick = () => {
  emit('click');
};
</script>

<template>
  <section class="flex flex-col w-full h-full overflow-hidden bg-n-surface-1">
    <header class="px-6 pt-6">
      <div
        class="flex flex-wrap items-start justify-between w-full max-w-5xl gap-3 mx-auto"
      >
        <div class="flex flex-col min-w-0 gap-1">
          <!-- `h2`, not `h1`: DashboardTopbar already owns the page's `h1`. -->
          <h2 class="mb-0 text-lg font-semibold tracking-tight text-n-slate-12">
            {{ headerTitle }}
          </h2>
          <p v-if="headerSubtitle" class="mb-0 text-sm text-n-slate-11">
            {{ headerSubtitle }}
          </p>
        </div>
        <!-- `relative` anchors dropdowns a page renders in the action slot. -->
        <div class="relative flex-shrink-0 group/campaign-button">
          <Button
            :label="buttonLabel"
            icon="i-lucide-plus"
            color="violet"
            size="sm"
            class="group-hover/campaign-button:brightness-110"
            @click="handleButtonClick"
          />
          <!-- The create panel is a teleported modal, so it renders at the body,
               not here; the slot only keeps it mounted with the page. -->
          <slot name="action" />
        </div>
      </div>
    </header>
    <div class="flex-1 px-6 pt-5 pb-8 overflow-y-auto">
      <div class="w-full max-w-5xl mx-auto">
        <slot name="default" />
      </div>
    </div>
  </section>
</template>
